

































































































































































import Vue from 'vue';
import { mapActions } from 'vuex';
import moment from 'moment';

import { Quote, QuoteType } from '@/models/quote';
import { cloneDeep } from 'lodash';
import CountryPicker from '../common/CountryPicker.vue';
import { ErrorManager } from '@/models/error';
import ErrorAlert from '../common/ErrorAlert.vue';
import ALDialog from '../core/Dialog/ALDialog.vue';
import mixins from '@/utils/mixins';
import QuoteLayoutMixin from '@/mixins/quotes/QuoteLayoutMixin';

export default mixins(QuoteLayoutMixin).extend({
  components: { CountryPicker, ErrorAlert, ALDialog },
  data: () => ({
    QuoteType,
    menu: false,
    valid: false as boolean,
    dialog: false as boolean,
    loading: false as boolean,
    error: '' as string,
    orderNumber: '' as string,
    poNumber: '' as string,
    hsCode: '' as string,
    originCountry: '',
    deliveryMode: '' as string,
    exfactoryDate: (null as unknown) as Date,
    language: 'en' as string,
    showHsCode: false,
    showCoo: false,
    languages: [
      {
        value: 'en',
        text: 'English'
      },
      {
        value: 'es',
        text: 'Spanish'
      },
      {
        value: 'ru',
        text: 'Russian'
      }
    ],
    quoteNumber: (null as unknown) as number,

    rules: [(v: any) => true],
    quote: new Quote(),

    detailErrorMessage: '',
    errorMessage: ''
  }),

  methods: {
    ...mapActions({
      exportProformaInvoice: 'quote/exportProformaInvoice'
    }),

    open(quote: Quote) {
      this.orderNumber = '';
      this.poNumber = '';
      this.hsCode = '8436.21.0000';
      this.originCountry = quote.isVentilationQuote() ? 'GB' : 'CA';
      this.deliveryMode = '';
      this.exfactoryDate = (null as unknown) as Date;
      this.language = 'en';

      this.quoteNumber = quote.number!;
      this.dialog = true;

      this.quote = cloneDeep(quote);

      if (quote.type == QuoteType.AFTER_MARKET_PARTS) {
        this.showHsCode = true;
        this.showCoo = true;
      }
    },

    close() {
      this.dialog = false;
    },

    clearAllErrors(): void {
      this.errorMessage = '';
      this.detailErrorMessage = '';
    },

    generateInvoice() {
      this.clearAllErrors();
      if ((this as any).$refs.form.validate()) {
        this.loading = true;
        this.exportProformaInvoice({
          quoteId: this.quoteNumber,
          orderNumber: this.orderNumber,
          poNumber: this.poNumber,
          hsCode: this.hsCode,
          originCountry: this.originCountry,
          deliveryMode: this.deliveryMode,
          exfactoryDate: this.exfactoryDate,
          language: this.language,
          showHsCode: this.showHsCode,
          showCoo: this.showCoo
        })
          .then((data: Blob) => {
            this.createPdf({ data, id: this.quoteNumber });
            this.close();
          })
          .catch(error => {
            if (error.response) {
              if (error.response.data.detail) {
                this.detailErrorMessage = error.response.data.detail;
              }
            }
            this.errorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    createPdf({ data, id }: { data: Blob; id: number }) {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      const linkName = `${id}-proforma-invoice-${moment(new Date()).format(
        'YYYY-MM-DD-HH-mm-ss'
      )}.pdf`;
      link.href = url;

      link.setAttribute('download', linkName); //or any other extension
      document.body.appendChild(link);
      link.click();
    }
  }
});
